import { OPERATION, SVC_TYPE, EMPTY_STRING } from '@constants/common';

export interface Notification {
  itemNotification: string,
  progressStatus: string,
  operationType: string,
}

export interface Account {
  userGuid: string,
  userName: string,
  firstName: string,
  lastName: string,
  isPublicUser: boolean,
  email?: string,
  contactNumber?: string,
  subcriptionFeaturePermissionModel?: SFPModel[]
}

export interface SFPModel {
  organisationGuid: string,
  permissionList: string[],
  featureList: string[]
}

interface AppUserRoleModel {
  roleGuid: string,
  organisationGuid: string,
}

export interface TabComponent {
  name: string,
  component
}

export interface FormComponents {
  [key: string]: FormComponent
}

interface FormComponent {
  label?: string,
  component,
  invalid?
}

export interface IServiceNotification {
  ADD: IActionNotification,
  GET: IActionNotification,
  UPDATE: IActionNotification,
  DELETE: IActionNotification,
  LIST: IActionNotification,
  RETRIEVE: IActionNotification,
}

export class IActionNotification {
  status: string;

  message?: string;

  isSuccess?: boolean;

  constructor(status, message = EMPTY_STRING, isSuccess = false) {
    this.status = status;
    this.message = message;
    this.isSuccess = isSuccess;
  }
}

export interface INotificationUpdate {
  serviceType: string,
  operationType: string,
  notification: IActionNotification
}

export interface CalendarInterval {
  start: Date,
  end: Date,
}

export interface AccountPermission {
  canUpdate?: boolean,
  canAdd?: boolean,
  canRead?: boolean,
  canDelete?: boolean,
}